import { useOutletContext, useSearchParams } from "react-router-dom";
import { CreditCard, IdCard, Clock, MapPin } from "lucide-react";
import { PageHeader } from "@/components/site/PageHeader";
import { LeadForm } from "@/components/site/LeadForm";
import { MapFrame } from "@/components/home/LocationSection";
import { Reveal, Stagger, Item } from "@/components/motion/Reveal";

export default function TestDrive() {
  const { settings, vehicles } = useOutletContext();
  const [params] = useSearchParams();
  const preselected = params.get("vehicle") || "";

  const bring = [
    { icon: IdCard, title: "Valid CNIC", text: "Original national identity card." },
    { icon: CreditCard, title: "Driving licence", text: "A valid Pakistani driving licence." },
    { icon: Clock, title: "About 45 minutes", text: "Enough for a proper drive and a walk-around." },
    { icon: MapPin, title: "Meet at the showroom", text: settings.address },
  ];

  return (
    <div data-testid="test-drive-page">
      <PageHeader eyebrow="Book a Test Drive" lines={["Feel it before", "you decide."]} sub="Choose a model and a day that suits you. Our team will call to confirm your slot at West Canal Road, Faisalabad." />
      <section className="wrap grid gap-14 pb-24 lg:grid-cols-12 sm:pb-32">
        <Reveal className="lg:col-span-7" y={40}>
          <LeadForm type="test_drive" vehicles={vehicles} defaultVehicle={preselected} settings={settings} />
        </Reveal>
        <div className="lg:col-span-5">
          <Reveal y={12}><p className="eyebrow mb-6">What to bring</p></Reveal>
          <Stagger className="divide-y divide-white/10 border-y border-white/10" gap={0.08}>
            {bring.map((b) => (
              <Item key={b.title} className="flex gap-5 py-5">
                <b.icon className="mt-1 h-5 w-5 shrink-0 text-crimson" />
                <div>
                  <p className="font-display text-lg font-semibold">{b.title}</p>
                  <p className="mt-1 text-sm text-slate-400">{b.text}</p>
                </div>
              </Item>
            ))}
          </Stagger>
          <Reveal className="mt-10" y={30} delay={0.2}>
            <MapFrame settings={settings} className="h-[300px]" />
          </Reveal>
        </div>
      </section>
    </div>
  );
}
